




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { IDetailRecord } from '@/store/tool/imgcolor/types';

// 图片预览
@Component
export default class ToolImgColorPreview extends Vue {
  @Prop() public data!: IDetailRecord;

  public host = process.env.VUE_APP_API_COLOR_UPLOAD_URL as string;

  // 原图
  public get origin() {
    return this.data ? `${this.host + this.data.thumbOrigin}?${this.data.timestamp}` : '';
  }

  // 处理图
  public get palleted() {
    return this.data ? `${this.host + this.data.thumbPalleted}?${this.data.timestamp}` : '';
  }

  // 色域图
  public get digram() {
    return this.data ? `${this.host + this.data.plotDigram}?${this.data.timestamp}` : '';
  }
}
